import styled, { keyframes } from 'styled-components/macro';

const call = keyframes`
    15% {

        background: rgba(256, 256, 256, 0.5);
        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
    }
    25% {
        background: rgba(256, 256, 256, 0.8);
        box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.5),
                    0 0 0 8px rgba(255, 255, 255, 0.3);
    }
    30% {
        box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.5),
                    0 0 0 12px rgba(255, 255, 255, 0.3);
    }
`;

export const RingingIndicator = styled.div`
  opacity: 0.7;
  background: rgba(256, 256, 256, 0.3);
  width: 20px;
  height: 20px;
  border-radius: 100%;
  animation: ${call} 1.5s ease infinite;

  top: 50%;
  left: 53%;
  transform: translateX(-50%) translateY(-50%);
  position: absolute;
  z-index: 4;
`;

const InteractionAnim = keyframes`
    0%{
        background-color: #ffffff00;
    }
    50%{
        background-color: #ffffff20;
    }
    0%{
        background-color: #ffffff00;
    }
    
`;

export const PhoneWrapper = styled.div<{ sizeRatio: number }>`
  cursor: pointer;
  position: absolute;
  left: ${({ sizeRatio }) => `calc(50% + ${179 * sizeRatio}px)`};
  top: ${({ sizeRatio }) => `${110 * sizeRatio}px`};
  width: ${({ sizeRatio }) => `${75 * sizeRatio}px`};
  height: ${({ sizeRatio }) => `${290 * sizeRatio}px`};
  background-color: #ffffff00;
  z-index: 4;

  &:hover {
    animation: ${InteractionAnim} 0.5s ease-in-out;
    animation-iteration-count: infinite;
    ${RingingIndicator} {
      display: none;
    }
  }

  border-radius: 3px;
  border-bottom-right-radius: 15px;
  border-top-right-radius: 5px;
`;
